import React, { Component } from 'react';
import { Grid, Typography, TextField, Button, CircularProgress } from '@material-ui/core';
import { validatePassword } from '../../Common';
import { withRouter, RouteComponentProps } from 'react-router';


type Props = {
    resetPasswordConfirm: (code: string, password: string) => void,
    code: string,
    message: string,
    success: boolean | null,
    isBusy: boolean
} & RouteComponentProps

type State = {
    password: string,
    password2: string,
    passwordsMatch: boolean | null,
    passwordFormatError: boolean,
}

class CreateNewPassword extends Component<Props, State>   {

    constructor(props: Props) {
        super(props)

        this.state = {
            password: '',
            password2: '',
            passwordsMatch: null,
            passwordFormatError: false,
        }
    }

    render() {
        return (
            <div>
                {this.props.message &&
                    <Grid container style={{ textAlign: 'center', padding: "15px" }}>
                        <Grid item xs={12} sm={12} md={12}>
                            <Typography variant="h3" >{this.props.message}</Typography>
                        </Grid>
                    </Grid>
                }

                {this.props.isBusy ?
                    <Grid container style={{ textAlign: 'center', padding: "15px" }}>
                        <Grid item sm={3} md={4}></Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <CircularProgress size={50}></CircularProgress>
                        </Grid>
                    </Grid>
                    :
                    <div>
                        {this.props.success === null &&
                            <Grid container style={{ textAlign: 'center', padding: "15px" }}>
                                <Grid item sm={3} md={4}></Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <TextField
                                        label="Your new password"
                                        type="password"
                                        autoComplete="current-password"
                                        margin="normal"
                                        variant="outlined"
                                        value={this.state.password}
                                        onChange={(e) => this.setState({ password: e.target.value, passwordFormatError: !validatePassword(e.target.value) })}
                                        style={{ width: '100%' }}
                                        helperText={this.state.passwordFormatError ? "Password have to consist of at least 8 characters, 1 uppercase, 1 lowercase, 1 numeric, and 1 special character." : ''}
                                        error={this.state.passwordFormatError}
                                    />
                                    <TextField
                                        label="Confirm your new password"
                                        type="password"
                                        autoComplete="current-password"
                                        margin="normal"
                                        variant="outlined"
                                        value={this.state.password2}
                                        onChange={(e) => this.setState({ password2: e.target.value, passwordsMatch: this.state.password === e.target.value })}
                                        style={{ width: '100%' }}
                                        helperText={this.state.passwordsMatch === null ? '' : (this.state.passwordsMatch ? '' : "Passwords are not matching.")}
                                        error={this.state.passwordsMatch === null ? false : !this.state.passwordsMatch}
                                    />
                                </Grid>
                                <Grid item sm={3} md={4}></Grid>
                                <Grid item sm={3} md={4}></Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Button
                                        style={{ width: '100%' }}
                                        variant="contained"
                                        color="primary"
                                        disabled={!this.state.passwordsMatch || this.state.passwordFormatError}
                                        onClick={(e) => this.props.resetPasswordConfirm(this.props.code, this.state.password)}>Set new password</Button>
                                </Grid>
                                <Grid item sm={3} md={4}></Grid>
                            </Grid>
                        }

                        {this.props.success === true &&
                            <Grid container style={{ textAlign: 'center', padding: "15px" }}>
                                <Grid item sm={3} md={4}></Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Button
                                        style={{ width: '100%' }}
                                        variant="contained"
                                        color="primary"
                                        onClick={(e) => this.props.history.push("/")}>Go to sign in</Button>
                                </Grid>
                                <Grid item sm={3} md={4}></Grid>
                            </Grid>
                        }

                        {this.props.success === false &&
                            <Grid container style={{ textAlign: 'center', padding: "15px" }}>
                                <Grid item sm={3} md={4}></Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Button
                                        style={{ width: '100%' }}
                                        variant="contained"
                                        color="primary"
                                        onClick={(e) => this.props.history.push("/Login")}>Go back</Button>
                                </Grid>
                                <Grid item sm={3} md={4}></Grid>
                            </Grid>
                        }

                    </div>
                }
            </div>
        );
    }
}

export default withRouter(CreateNewPassword);